export default __webpack_public_path__ + "static/media/twitch.7e2c4fff.svg";